module.exports = {"content":{},"productInfo":{"code":"{032B6615-4C40-4C76-8D1C-859B61CE64C4}","name":"トルコ語　初中級","serialHead":"ZTKXM","courseResourceIDs":[{"levelNo":1,"resourceID":"f153519a1e47ae9155c80a5ee457a3c2dfea637a"},{"levelNo":2,"resourceID":"2d258ecdcf518ef4d2a24f5af38aeaec14658261"},{"levelNo":3,"resourceID":"ff823f9c8b435685527ecc21912cca25ef3d52e9"}],"language":"tr-TR","challengeCount":21573},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1